import ComingSoonModel from './coming-soon.model';
import MovieModel from './movie.model';
import NewsModel from './news.model';
import PublishedShowtimesModel from './published-showtimes.model'
import ScheduleModel from './schedule.model';
import TheaterModel from './theater.model';
import UserModel from './user.model';


export default {
  ComingSoonModel,
  MovieModel,
  NewsModel,
  PublishedShowtimesModel,
  ScheduleModel,
  TheaterModel,
  UserModel,
};


